







// import endpoint from "../Api/endpoint"

// // Token icon mapping for verified tokens (optional - for fastest loading)
// // Place corresponding PNG/SVG files in frontend/public/tokens/
// const TOKEN_ICON_MAP = {
//   // Native token
//   "0x0000000000000000000000000000000000000000": "/tokens/MON.png",
// }

// const CACHE_KEY = "monad_token_icons_cache"
// const CACHE_VERSION = "v1"
// const CACHE_TTL = 7 * 24 * 60 * 60 * 1000 // 7 days in milliseconds

// // In-memory cache for fastest access
// const iconCache = new Map()

// const loadCacheFromStorage = () => {
//   try {
//     const stored = localStorage.getItem(CACHE_KEY)
//     if (!stored) return

//     const { version, timestamp, data } = JSON.parse(stored)

//     // Check if cache is valid (correct version and not expired)
//     if (version !== CACHE_VERSION) {
//       console.log("[v0] 🗑️  Cache version mismatch, clearing old cache")
//       localStorage.removeItem(CACHE_KEY)
//       return
//     }

//     const now = Date.now()
//     if (now - timestamp > CACHE_TTL) {
//       console.log("[v0] 🗑️  Cache expired, clearing old cache")
//       localStorage.removeItem(CACHE_KEY)
//       return
//     }

//     // Load valid cache into memory
//     Object.entries(data).forEach(([address, icon]) => {
//       iconCache.set(address, icon)
//     })

//     console.log(`[v0] 💾 Loaded ${Object.keys(data).length} icons from localStorage cache`)
//   } catch (error) {
//     console.error("[v0] ❌ Failed to load cache from localStorage:", error)
//     localStorage.removeItem(CACHE_KEY)
//   }
// }

// const saveCacheToStorage = () => {
//   try {
//     const data = Object.fromEntries(iconCache)
//     const cacheData = {
//       version: CACHE_VERSION,
//       timestamp: Date.now(),
//       data,
//     }
//     localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData))
//     console.log(`[v0] 💾 Saved ${Object.keys(data).length} icons to localStorage cache`)
//   } catch (error) {
//     console.error("[v0] ❌ Failed to save cache to localStorage:", error)
//   }
// }

// loadCacheFromStorage()

// /**
//  * Fetch token icon from backend API (which checks Redis first, then BlockVision)
//  * @param {string} address - Token contract address
//  * @returns {Promise<string>} Icon URL
//  */
// const fetchFromBackendAPI = async (address) => {
//   try {
//     console.log("\n" + "=".repeat(80))
//     console.log("[v0] 🔵 BACKEND API - FETCHING TOKEN LOGO FROM REDIS/BLOCKVISION")
//     console.log("[v0] 🔵 Token Address:", address)
//     console.log("[v0] 🔵 API URL:", `${endpoint.token}/${address}`)
//     console.log("=".repeat(80))

//     const response = await fetch(`${endpoint.token}/${address}`)

//     console.log("\n[v0] 🔵 BACKEND API - Response Status:", response.status, response.statusText)

//     if (!response.ok) {
//       console.log("[v0] 🔵 BACKEND API - ❌ FAILED - HTTP Error:", response.status)
//       console.log("=".repeat(80) + "\n")
//       return ""
//     }

//     const result = await response.json()
//     console.log("\n[v0] 🔵 BACKEND API - RESPONSE DATA:")
//     console.log(JSON.stringify(result, null, 2))

//     const icon = result?.data?.icon

//     if (icon && icon !== "") {
//       console.log("\n[v0] 🔵 BACKEND API - ✅ SUCCESS!")
//       console.log("[v0] 🔵 Logo URL Found:", icon)
//       console.log("[v0] 🔵 Source: Redis Cache or BlockVision API")
//       console.log("=".repeat(80) + "\n")
//       return icon
//     }

//     console.log("\n[v0] 🔵 BACKEND API - ⚠️  No icon returned (empty string)")
//     console.log("=".repeat(80) + "\n")
//     return ""
//   } catch (error) {
//     console.log("\n[v0] 🔵 BACKEND API - ❌ ERROR OCCURRED")
//     console.log("[v0] 🔵 Error Message:", error.message)
//     console.log("=".repeat(80) + "\n")
//     return ""
//   }
// }

// /**
//  * Generate a deterministic avatar based on token address
//  * @param {string} address - Token contract address
//  * @returns {string} Data URI for generated avatar
//  */
// const generateTokenAvatar = (address) => {
//   console.log("[v0] 🎨 GENERATING FALLBACK AVATAR for:", address)
//   const seed = address.toLowerCase()
//   const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=${seed}&backgroundColor=transparent`
//   console.log("[v0] 🎨 Avatar URL:", avatarUrl)
//   return avatarUrl
// }

// /**
//  * Fetch token icon from backend API (which uses Redis + BlockVision)
//  * @param {string} address - Token contract address
//  * @returns {Promise<string>} Icon URL
//  */
// export const fetchTokenIcon = async (address) => {
//   if (!address) {
//     console.log("[v0] ⚠️  No address provided, using placeholder")
//     return "/placeholder.svg"
//   }

//   const normalizedAddress = address.toLowerCase()

//   if (iconCache.has(normalizedAddress)) {
//     const cachedIcon = iconCache.get(normalizedAddress)
//     console.log("[v0] 💾 CACHE HIT - Using cached icon for:", address)
//     console.log("[v0] 📍 Icon URL:", cachedIcon)
//     return cachedIcon
//   }

//   const staticIcon = TOKEN_ICON_MAP[normalizedAddress]
//   if (staticIcon) {
//     console.log("[v0] 📁 STATIC - Using static hosted icon:", staticIcon)
//     iconCache.set(normalizedAddress, staticIcon)
//     saveCacheToStorage()
//     return staticIcon
//   }

//   console.log("\n" + "█".repeat(80))
//   console.log("[v0] 🔄 FETCHING ICON FROM BACKEND API (Redis → BlockVision)")
//   console.log("[v0] 📍 Token Address:", address)
//   console.log("█".repeat(80))

//   const icon = await fetchFromBackendAPI(address)

//   if (icon && icon !== "") {
//     console.log("\n" + "█".repeat(80))
//     console.log("[v0] ✅ ICON FETCH SUCCESSFUL FROM BACKEND API")
//     console.log("[v0] 📍 Final Icon URL:", icon)
//     console.log("█".repeat(80) + "\n")
//     iconCache.set(normalizedAddress, icon)
//     saveCacheToStorage()
//     return icon
//   }

//   console.log("\n" + "█".repeat(80))
//   console.log("[v0] 🎨 FALLBACK - Using generated avatar")
//   const avatar = generateTokenAvatar(address)
//   console.log("█".repeat(80) + "\n")
//   iconCache.set(normalizedAddress, avatar)
//   saveCacheToStorage()
//   return avatar
// }

// /**
//  * Get token icon URL with fallback logic (synchronous version)
//  * Priority: Cache → Static hosted → API provided → Generated avatar
//  *
//  * @param {string} address - Token contract address
//  * @param {string} apiIcon - Icon URL from API (optional)
//  * @returns {string} Icon URL
//  */
// export const getTokenIcon = (address, apiIcon) => {
//   if (!address) return "/placeholder.svg"

//   const normalizedAddress = address.toLowerCase()

//   if (iconCache.has(normalizedAddress)) {
//     return iconCache.get(normalizedAddress)
//   }

//   const staticIcon = TOKEN_ICON_MAP[normalizedAddress]
//   if (staticIcon) {
//     return staticIcon
//   }

//   if (apiIcon && apiIcon !== "") {
//     iconCache.set(normalizedAddress, apiIcon)
//     saveCacheToStorage()
//     return apiIcon
//   }

//   return generateTokenAvatar(address)
// }

// /**
//  * Check if a token has a static hosted icon
//  * @param {string} address - Token contract address
//  * @returns {boolean}
//  */
// export const hasStaticIcon = (address) => {
//   if (!address) return false
//   return TOKEN_ICON_MAP[address.toLowerCase()] !== undefined
// }

// /**
//  * Preload icons for a list of tokens by fetching from backend API
//  * Backend checks Redis first, then BlockVision if not found
//  * @param {Array<{address: string, icon?: string}>} tokens - Array of token objects
//  * @returns {Promise<void>}
//  */
// export const preloadTokenIcons = async (tokens) => {
//   console.log("\n" + "█".repeat(80))
//   console.log("[v0] 🔄 PRELOADING ICONS FOR", tokens.length, "TOKENS")
//   console.log("[v0] 📍 Source: Backend API (Redis → BlockVision)")
//   console.log("█".repeat(80) + "\n")

//   let foundInCache = 0
//   let foundInAPI = 0
//   let needsFetch = 0

//   tokens.forEach((token, index) => {
//     if (!token.address) {
//       console.log(`[v0] ⏭️  SKIP [${index + 1}/${tokens.length}] - No address for token:`, token.name || "Unknown")
//       return
//     }

//     const normalizedAddress = token.address.toLowerCase()

//     // Check if already in cache
//     if (iconCache.has(normalizedAddress)) {
//       foundInCache++
//       console.log(`[v0] ✅ [${index + 1}/${tokens.length}] ${token.name || token.code || "Unknown"} - Found in cache`)
//       return
//     }

//     // Check if API provided an icon
//     if (token.icon && token.icon !== "") {
//       foundInAPI++
//       iconCache.set(normalizedAddress, token.icon)
//       console.log(
//         `[v0] ✅ [${index + 1}/${tokens.length}] ${token.name || token.code || "Unknown"} - Icon from API response`,
//       )
//       return
//     }

//     // Needs to be fetched
//     needsFetch++
//     console.log(
//       `[v0] ⚠️  [${index + 1}/${tokens.length}] ${token.name || token.code || "Unknown"} - Needs fetch from backend`,
//     )
//   })

//   if (needsFetch > 0) {
//     console.log("\n" + "█".repeat(80))
//     console.log(`[v0] 🔄 FETCHING ${needsFetch} MISSING ICONS FROM BACKEND API...`)
//     console.log("█".repeat(80) + "\n")

//     const tokensToFetch = tokens.filter((token) => {
//       if (!token.address) return false
//       const normalizedAddress = token.address.toLowerCase()
//       return !iconCache.has(normalizedAddress) && (!token.icon || token.icon === "")
//     })

//     // Fetch in batches to avoid overwhelming the API
//     const batchSize = 5
//     for (let i = 0; i < tokensToFetch.length; i += batchSize) {
//       const batch = tokensToFetch.slice(i, i + batchSize)
//       await Promise.all(
//         batch.map(async (token) => {
//           try {
//             const icon = await fetchTokenIcon(token.address)
//             if (icon && icon !== "") {
//               console.log(`[v0] ✅ Fetched icon for ${token.name || token.code || "Unknown"}`)
//             }
//           } catch (error) {
//             console.error(`[v0] ❌ Failed to fetch icon for ${token.name || token.code || "Unknown"}:`, error.message)
//           }
//         }),
//       )

//       // Add a small delay between batches to avoid rate limiting
//       if (i + batchSize < tokensToFetch.length) {
//         await new Promise((resolve) => setTimeout(resolve, 500))
//       }
//     }

//     saveCacheToStorage()
//   }

//   console.log("\n" + "█".repeat(80))
//   console.log("[v0] ✅ ICON PRELOAD COMPLETE")
//   console.log("[v0] 📊 Total tokens:", tokens.length)
//   console.log("[v0] 📊 Found in cache:", foundInCache)
//   console.log("[v0] 📊 Found in API response:", foundInAPI)
//   console.log("[v0] 📊 Fetched from backend:", needsFetch)
//   console.log("█".repeat(80) + "\n")
// }

// export const clearIconCache = () => {
//   iconCache.clear()
//   localStorage.removeItem(CACHE_KEY)
//   console.log("[v0] 🗑️  Icon cache cleared")
// }

// export default TOKEN_ICON_MAP









import endpoint from "../Api/endpoint"

// Token icon mapping for verified tokens (optional - for fastest loading)
// Place corresponding PNG/SVG files in frontend/public/tokens/
const TOKEN_ICON_MAP = {
  // Native token
  "0x0000000000000000000000000000000000000000": "/tokens/MON.png",
}

const CACHE_KEY = "monad_token_icons_cache"
const CACHE_VERSION = "v1"
const CACHE_TTL = 7 * 24 * 60 * 60 * 1000 // 7 days in milliseconds

// In-memory cache for fastest access
const iconCache = new Map()

// Cache statistics tracking
const cacheStats = {
  hits: 0,
  misses: 0,
  apiCalls: 0,
  staticIcons: 0,
  generatedAvatars: 0,
}

const loadCacheFromStorage = () => {
  try {
    const stored = localStorage.getItem(CACHE_KEY)
    if (!stored) return

    const { version, timestamp, data } = JSON.parse(stored)

    // Check if cache is valid (correct version and not expired)
    if (version !== CACHE_VERSION) {
      console.log("[v0] 🗑️  Cache version mismatch, clearing old cache")
      localStorage.removeItem(CACHE_KEY)
      return
    }

    const now = Date.now()
    if (now - timestamp > CACHE_TTL) {
      console.log("[v0] 🗑️  Cache expired, clearing old cache")
      localStorage.removeItem(CACHE_KEY)
      return
    }

    // Load valid cache into memory
    Object.entries(data).forEach(([address, icon]) => {
      iconCache.set(address, icon)
    })

    console.log(`[v0] 💾 Loaded ${Object.keys(data).length} icons from localStorage cache`)
  } catch (error) {
    console.error("[v0] ❌ Failed to load cache from localStorage:", error)
    localStorage.removeItem(CACHE_KEY)
  }
}

const saveCacheToStorage = () => {
  try {
    const data = Object.fromEntries(iconCache)
    const cacheData = {
      version: CACHE_VERSION,
      timestamp: Date.now(),
      data,
    }
    localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData))
    console.log(`[v0] 💾 Saved ${Object.keys(data).length} icons to localStorage cache`)
  } catch (error) {
    console.error("[v0] ❌ Failed to save cache to localStorage:", error)
  }
}

loadCacheFromStorage()

/**
 * Fetch token icon from backend API (which checks Redis first, then BlockVision)
 * @param {string} address - Token contract address
 * @returns {Promise<string>} Icon URL
 */
const fetchFromBackendAPI = async (address) => {
  try {
    console.log("\n" + "=".repeat(80))
    console.log("[v0] 🔵 BACKEND API - FETCHING TOKEN LOGO FROM REDIS/BLOCKVISION")
    console.log("[v0] 🔵 Token Address:", address)
    console.log("[v0] 🔵 API URL:", `${endpoint.token}/${address}`)
    console.log("=".repeat(80))

    const response = await fetch(`${endpoint.token}/${address}`)

    console.log("\n[v0] 🔵 BACKEND API - Response Status:", response.status, response.statusText)

    if (!response.ok) {
      console.log("[v0] 🔵 BACKEND API - ❌ FAILED - HTTP Error:", response.status)
      console.log("=".repeat(80) + "\n")
      return ""
    }

    const result = await response.json()
    console.log("\n[v0] 🔵 BACKEND API - RESPONSE DATA:")
    console.log(JSON.stringify(result, null, 2))

    const icon = result?.data?.icon

    if (icon && icon !== "") {
      console.log("\n[v0] 🔵 BACKEND API - ✅ SUCCESS!")
      console.log("[v0] 🔵 Logo URL Found:", icon)
      console.log("[v0] 🔵 Source: Redis Cache or BlockVision API")
      console.log("=".repeat(80) + "\n")
      return icon
    }

    console.log("\n[v0] 🔵 BACKEND API - ⚠️  No icon returned (empty string)")
    console.log("=".repeat(80) + "\n")
    return ""
  } catch (error) {
    console.log("\n[v0] 🔵 BACKEND API - ❌ ERROR OCCURRED")
    console.log("[v0] 🔵 Error Message:", error.message)
    console.log("=".repeat(80) + "\n")
    return ""
  }
}

/**
 * Generate a deterministic avatar based on token address
 * @param {string} address - Token contract address
 * @returns {string} Data URI for generated avatar
 */
const generateTokenAvatar = (address) => {
  console.log("[v0] 🎨 GENERATING FALLBACK AVATAR for:", address)
  const seed = address.toLowerCase()
  const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=${seed}&backgroundColor=transparent`
  console.log("[v0] 🎨 Avatar URL:", avatarUrl)
  return avatarUrl
}

/**
 * Fetch token icon from backend API (which uses Redis + BlockVision)
 * @param {string} address - Token contract address
 * @returns {Promise<string>} Icon URL
 */
export const fetchTokenIcon = async (address) => {
  if (!address) {
    console.log("[v0] ⚠️  No address provided, using placeholder")
    return "/placeholder.svg"
  }

  const normalizedAddress = address.toLowerCase()

  if (iconCache.has(normalizedAddress)) {
    const cachedIcon = iconCache.get(normalizedAddress)
    cacheStats.hits++
    console.log("\n" + "🟢".repeat(40))
    console.log("[v0] ✅ CACHE HIT - Icon already cached!")
    console.log("[v0] 📍 Token Address:", address)
    console.log("[v0] 📍 Icon URL:", cachedIcon)
    console.log("[v0] 📊 Cache Stats - Hits:", cacheStats.hits, "| Misses:", cacheStats.misses)
    console.log("🟢".repeat(40) + "\n")
    return cachedIcon
  }

  const staticIcon = TOKEN_ICON_MAP[normalizedAddress]
  if (staticIcon) {
    cacheStats.staticIcons++
    console.log("[v0] 📁 STATIC - Using static hosted icon:", staticIcon)
    iconCache.set(normalizedAddress, staticIcon)
    saveCacheToStorage()
    return staticIcon
  }

  cacheStats.misses++
  cacheStats.apiCalls++

  console.log("\n" + "🔴".repeat(40))
  console.log("[v0] ❌ CACHE MISS - Fetching from backend API")
  console.log("[v0] 📍 Token Address:", address)
  console.log("[v0] 📊 Cache Stats - Hits:", cacheStats.hits, "| Misses:", cacheStats.misses)
  console.log("🔴".repeat(40))

  console.log("\n" + "█".repeat(80))
  console.log("[v0] 🔄 FETCHING ICON FROM BACKEND API (Redis → BlockVision)")
  console.log("[v0] 📍 Token Address:", address)
  console.log("█".repeat(80))

  const icon = await fetchFromBackendAPI(address)

  if (icon && icon !== "") {
    console.log("\n" + "█".repeat(80))
    console.log("[v0] ✅ ICON FETCH SUCCESSFUL FROM BACKEND API")
    console.log("[v0] 📍 Final Icon URL:", icon)
    console.log("█".repeat(80) + "\n")
    iconCache.set(normalizedAddress, icon)
    saveCacheToStorage()
    return icon
  }

  cacheStats.generatedAvatars++
  console.log("\n" + "█".repeat(80))
  console.log("[v0] 🎨 FALLBACK - Using generated avatar")
  const avatar = generateTokenAvatar(address)
  console.log("█".repeat(80) + "\n")
  iconCache.set(normalizedAddress, avatar)
  saveCacheToStorage()
  return avatar
}

/**
 * Get token icon URL with fallback logic (synchronous version)
 * Priority: Cache → Static hosted → API provided → Generated avatar
 *
 * @param {string} address - Token contract address
 * @param {string} apiIcon - Icon URL from API (optional)
 * @returns {string} Icon URL
 */
export const getTokenIcon = (address, apiIcon) => {
  if (!address) return "/placeholder.svg"

  const normalizedAddress = address.toLowerCase()

  if (iconCache.has(normalizedAddress)) {
    return iconCache.get(normalizedAddress)
  }

  const staticIcon = TOKEN_ICON_MAP[normalizedAddress]
  if (staticIcon) {
    return staticIcon
  }

  if (apiIcon && apiIcon !== "") {
    iconCache.set(normalizedAddress, apiIcon)
    saveCacheToStorage()
    return apiIcon
  }

  return generateTokenAvatar(address)
}

/**
 * Check if a token has a static hosted icon
 * @param {string} address - Token contract address
 * @returns {boolean}
 */
export const hasStaticIcon = (address) => {
  if (!address) return false
  return TOKEN_ICON_MAP[address.toLowerCase()] !== undefined
}

/**
 * Check if an icon URL is a generated dicebear avatar
 * @param {string} iconUrl - Icon URL to check
 * @returns {boolean}
 */
export const isDicebearAvatar = (iconUrl) => {
  if (!iconUrl) return false
  return iconUrl.includes("api.dicebear.com")
}

/**
 * Update a cached icon if the current one is a dicebear placeholder
 * and a real icon is now available
 * @param {string} address - Token contract address
 * @param {string} newIcon - New icon URL from API
 * @returns {boolean} - True if icon was updated, false otherwise
 */
export const updateCachedIcon = (address, newIcon) => {
  if (!address || !newIcon || newIcon === "") {
    return false
  }

  const normalizedAddress = address.toLowerCase()
  const cachedIcon = iconCache.get(normalizedAddress)

  // If no cached icon exists, just cache the new one
  if (!cachedIcon) {
    console.log(`[v0] 💾 Caching new icon for ${address}:`, newIcon)
    iconCache.set(normalizedAddress, newIcon)
    saveCacheToStorage()
    return true
  }

  // If cached icon is a dicebear avatar and new icon is different, update it
  if (isDicebearAvatar(cachedIcon) && !isDicebearAvatar(newIcon) && cachedIcon !== newIcon) {
    console.log(`[v0] 🔄 UPGRADING ICON for ${address}`)
    console.log(`[v0]    Old (dicebear): ${cachedIcon}`)
    console.log(`[v0]    New (real logo): ${newIcon}`)
    iconCache.set(normalizedAddress, newIcon)
    saveCacheToStorage()
    return true
  }

  return false
}

/**
 * Batch update cached icons for multiple tokens
 * Replaces dicebear placeholders with real icons from API
 * @param {Array<{address: string, icon: string}>} tokens - Array of token objects with icons
 * @returns {number} - Number of icons updated
 */
export const batchUpdateCachedIcons = (tokens) => {
  if (!tokens || tokens.length === 0) return 0

  let updatedCount = 0

  tokens.forEach((token) => {
    if (token.address && token.icon) {
      const wasUpdated = updateCachedIcon(token.address, token.icon)
      if (wasUpdated) {
        updatedCount++
      }
    }
  })

  if (updatedCount > 0) {
    console.log(`[v0] ✅ Updated ${updatedCount} icon(s) from dicebear placeholders to real logos`)
  }

  return updatedCount
}

/**
 * Preload icons for a list of tokens by fetching from backend API
 * Backend checks Redis first, then BlockVision if not found
 * @param {Array<{address: string, icon?: string}>} tokens - Array of token objects
 * @returns {Promise<void>}
 */
export const preloadTokenIcons = async (tokens) => {
  console.log("\n" + "█".repeat(80))
  console.log("[v0] 🔄 PRELOADING ICONS FOR", tokens.length, "TOKENS")
  console.log("[v0] 📍 Source: Backend API (Redis → BlockVision)")
  console.log("█".repeat(80) + "\n")

  let foundInCache = 0
  let foundInAPI = 0
  let needsFetch = 0

  tokens.forEach((token, index) => {
    if (!token.address) {
      console.log(`[v0] ⏭️  SKIP [${index + 1}/${tokens.length}] - No address for token:`, token.name || "Unknown")
      return
    }

    const normalizedAddress = token.address.toLowerCase()

    // Check if already in cache
    if (iconCache.has(normalizedAddress)) {
      foundInCache++
      console.log(`[v0] ✅ [${index + 1}/${tokens.length}] ${token.name || token.code || "Unknown"} - Found in cache`)
      return
    }

    // Check if API provided an icon
    if (token.icon && token.icon !== "") {
      foundInAPI++
      iconCache.set(normalizedAddress, token.icon)
      console.log(
        `[v0] ✅ [${index + 1}/${tokens.length}] ${token.name || token.code || "Unknown"} - Icon from API response`,
      )
      return
    }

    // Needs to be fetched
    needsFetch++
    console.log(
      `[v0] ⚠️  [${index + 1}/${tokens.length}] ${token.name || token.code || "Unknown"} - Needs fetch from backend`,
    )
  })

  if (needsFetch > 0) {
    console.log("\n" + "█".repeat(80))
    console.log(`[v0] 🔄 FETCHING ${needsFetch} MISSING ICONS FROM BACKEND API...`)
    console.log("█".repeat(80) + "\n")

    const tokensToFetch = tokens.filter((token) => {
      if (!token.address) return false
      const normalizedAddress = token.address.toLowerCase()
      return !iconCache.has(normalizedAddress) && (!token.icon || token.icon === "")
    })

    // Fetch in batches to avoid overwhelming the API
    const batchSize = 5
    for (let i = 0; i < tokensToFetch.length; i += batchSize) {
      const batch = tokensToFetch.slice(i, i + batchSize)
      await Promise.all(
        batch.map(async (token) => {
          try {
            const icon = await fetchTokenIcon(token.address)
            if (icon && icon !== "") {
              console.log(`[v0] ✅ Fetched icon for ${token.name || token.code || "Unknown"}`)
            }
          } catch (error) {
            console.error(`[v0] ❌ Failed to fetch icon for ${token.name || token.code || "Unknown"}:`, error.message)
          }
        }),
      )

      // Add a small delay between batches to avoid rate limiting
      if (i + batchSize < tokensToFetch.length) {
        await new Promise((resolve) => setTimeout(resolve, 500))
      }
    }

    saveCacheToStorage()
  }

  console.log("\n" + "█".repeat(80))
  console.log("[v0] ✅ ICON PRELOAD COMPLETE")
  console.log("[v0] 📊 Total tokens:", tokens.length)
  console.log("[v0] 📊 Found in cache:", foundInCache)
  console.log("[v0] 📊 Found in API response:", foundInAPI)
  console.log("[v0] 📊 Fetched from backend:", needsFetch)
  console.log("█".repeat(80) + "\n")
}

export const clearIconCache = () => {
  iconCache.clear()
  localStorage.removeItem(CACHE_KEY)
  console.log("[v0] 🗑️  Icon cache cleared")
}

// Function to view cache statistics
export const getCacheStats = () => {
  const cacheSize = iconCache.size
  const storageData = localStorage.getItem(CACHE_KEY)
  const storageSize = storageData ? (storageData.length / 1024).toFixed(2) : 0

  const stats = {
    ...cacheStats,
    cacheSize,
    storageSize: `${storageSize} KB`,
    hitRate:
      cacheStats.hits + cacheStats.misses > 0
        ? `${((cacheStats.hits / (cacheStats.hits + cacheStats.misses)) * 100).toFixed(1)}%`
        : "0%",
  }

  console.log("\n" + "═".repeat(80))
  console.log("📊 TOKEN ICON CACHE STATISTICS")
  console.log("═".repeat(80))
  console.log("Cache Performance:")
  console.log(`  ✅ Cache Hits: ${stats.hits}`)
  console.log(`  ❌ Cache Misses: ${stats.misses}`)
  console.log(`  📈 Hit Rate: ${stats.hitRate}`)
  console.log("\nIcon Sources:")
  console.log(`  🌐 API Calls: ${stats.apiCalls}`)
  console.log(`  📁 Static Icons: ${stats.staticIcons}`)
  console.log(`  🎨 Generated Avatars: ${stats.generatedAvatars}`)
  console.log("\nCache Storage:")
  console.log(`  💾 Icons in Memory: ${stats.cacheSize}`)
  console.log(`  💾 localStorage Size: ${stats.storageSize}`)
  console.log("═".repeat(80) + "\n")

  return stats
}

// Function to list all cached icons
export const listCachedIcons = () => {
  console.log("\n" + "═".repeat(80))
  console.log("📋 CACHED TOKEN ICONS")
  console.log("═".repeat(80))
  console.log(`Total cached icons: ${iconCache.size}`)
  console.log("─".repeat(80))

  Array.from(iconCache.entries()).forEach(([address, icon], index) => {
    console.log(`${index + 1}. ${address}`)
    console.log(`   → ${icon}`)
  })

  console.log("═".repeat(80) + "\n")

  return Array.from(iconCache.entries())
}

export default TOKEN_ICON_MAP
